var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.9992V12.6742C20 9.07422 19.225 6.32422 15.025 6.32422C13 6.32422 11.65 7.42422 11.1 8.47422H11.05V6.64922H7.07495V19.9992H11.225V13.3742C11.225 11.6242 11.55 9.94922 13.7 9.94922C15.825 9.94922 15.85 11.9242 15.85 13.4742V19.9742H20V19.9992Z",
    fill: "#295F98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.324951 6.65039H4.47495V20.0004H0.324951V6.65039Z",
    fill: "#295F98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 0C1.075 0 0 1.075 0 2.4C0 3.725 1.075 4.825 2.4 4.825C3.725 4.825 4.8 3.725 4.8 2.4C4.8 1.075 3.725 0 2.4 0Z",
    fill: "#295F98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e9d375cb87a3ab87d813b9b3027573d9.svg";
export { ForwardRef as ReactComponent };